import React from "react";

export default function Privacy() {
  return (
    <div className="mx-auto max-w-6xl px-4 pt-10">
      <div className="rounded-3xl border border-white/10 bg-white/5 p-6 md:p-10">
        <h1 className="text-2xl font-bold">Privacy Policy</h1>
        <p className="mt-4 text-white/70">
          Effective date: January 21, 2026

This Privacy Policy explains how AM Rental (“we”, “us”, “our”) handles information when you visit amrental.eu (the “Website”).

1. Who we are (Controller)

AM Rental
Address: Ivan Vazov 38, Floor 3, Sredets District, Sofia, Bulgaria
Phone: +359999991948
Email: support@amrental.eu

2. Summary

The Website is a static informational page.

We do not collect, store, or process personal data through the Website.

We do not use contact forms, user accounts, comments, or online payments on the Website.

3. Information we do not collect

We do not collect personal data such as:

names, emails, phone numbers submitted via the Website;

account information (there are no accounts);

payment information (there are no payments);

precise geolocation.

4. Cookies and similar technologies

We do not set cookies or use tracking technologies from our side.

Note: If the Website is hosted by a third-party hosting provider/CDN, the provider may automatically process limited technical data (e.g., IP address, request logs) to deliver and secure the service. This processing is performed by the hosting provider under their own policies and may be outside our direct control.

5. Analytics and advertising

We do not use:

Google Analytics or similar analytics tools,

advertising pixels (Meta/Facebook Pixel, TikTok Pixel, etc.),

remarketing or behavioral advertising.

6. Embedded content and third-party links

The Website may contain links to third-party websites. If you follow those links, those sites may collect data under their own privacy policies. We are not responsible for their practices.

7. Data sharing

Because we do not collect personal data through the Website, we do not sell, rent, or share website-collected personal data with third parties.

8. Data retention

We do not retain personal data collected via the Website because none is collected.

9. Your rights (EU/EEA visitors)

If you believe we are processing your personal data related to the Website, you can contact us at support@amrental.eu
 and we will review your request.

10. Changes to this policy

We may update this Privacy Policy from time to time. The “Effective date” at the top indicates when it was last updated.

11. Contact

If you have questions about this Privacy Policy, contact: support@amrental.eu
.
        </p>
      </div>
    </div>
  );
}
